import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import EventButton from '../../../atoms/EventButton/EventButton';
import { FloatPropType } from '../../../services/proptypes';
export default function CarouselArrow(_ref) {
  var orientation = _ref.orientation,
      onToggle = _ref.onToggle,
      currentIndex = _ref.currentIndex;
  return /*#__PURE__*/React.createElement(EventButton, {
    "aria-label": "See " + (orientation === 'right' ? 'next' : 'previous') + " image",
    event: {
      category: 'Image-Collection',
      action: 'Click',
      label: orientation
    },
    secondary: true,
    circular: true,
    icon: "angle " + orientation,
    onClick: function onClick() {
      return onToggle(currentIndex + (orientation === 'right' ? 1 : -1));
    },
    className: "ic-carousel-arrow",
    style: _extends({}, orientation === 'right' ? {
      right: -15
    } : {
      left: -15
    })
  });
}